import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { SessionCookieService } from '@app/core/cookies';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '@env/environment';
import { AuthModalComponent } from '@app/core/user/containers/auth-modal/auth-modal.component';

export class FeatureGuard implements CanActivate {
  private matDialogConfig = {
    disableClose: false,
    maxWidth: 1280,
    data: {
      type: 'login',
      forced: true
    }
  };

  featureName = '';

  constructor(protected sessionService: SessionCookieService, protected router: Router, protected dialog: MatDialog) {}

  canActivate(): Observable<boolean> {
    if (this.featureName && !environment.feature[this.featureName]) {
      this.router.navigate(['/']);
      return of(false);
    }

    const hasAuthenticationCookies = this.sessionService.hasSession() && this.sessionService.hasUserId();

    if (!hasAuthenticationCookies) {
      const dialogRef = this.dialog.open(AuthModalComponent, this.matDialogConfig);
      return dialogRef.afterClosed().pipe(
        map(res => {
          if (res === 'success') {
            return true;
          } else {
            this.router.navigate(['/']);
            return false;
          }
        })
      );
    }
    return of(true);
  }
}
